// @file Network requests related to Whiteboard Card Templates
/* eslint-disable no-return-await, no-template-curly-in-string */
import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { Id, WhiteboardCardTemplate } from '@@/types'
import type { JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

class WhiteboardCardTemplatesApi extends FetchableObject {
  public static get url(): string {
    return `/api/\${ apiVersion }/whiteboard/card-templates`
  }

  public static async fetch(
    { wallId }: { wallId: Id },
    fetchOptions: VersionedFetchOptions = { apiVersion: 1 },
  ): Promise<WhiteboardCardTemplate[]> {
    const { apiVersion = 1, ...otherFetchOptions } = fetchOptions
    const response: JsonAPIResponse<WhiteboardCardTemplate> = await fetchJson(this.buildUrl(this.url, { apiVersion }), {
      method: HTTPMethod.get,
      ...otherFetchOptions,
      query: { wall_id: `${wallId}` },
    })
    const data = Array.isArray(response.data) ? response.data : [response.data]
    return data.map((e) => e?.attributes).filter(Boolean) as WhiteboardCardTemplate[]
  }
}

export { WhiteboardCardTemplatesApi }
